const ModuleCardDescription = ({ descriptionText }) => {
    if (!descriptionText) return <div style={{ flex: 1 }} />;

    return (
        <p
            className="fs11px fw400 c15 op70 m0 h100 df aife"
            style={{
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden'
            }}
        >
            {
                (() => {
                    if (descriptionText.length <= 30) return descriptionText;

                    const breakIndex = descriptionText.lastIndexOf(' ', 30);

                    if (breakIndex === -1) {
                        return (
                            <>
                                {descriptionText.slice(0, 30)}
                                <br />
                                {descriptionText.slice(30)}
                            </>
                        );
                    }

                    return (
                        <>
                            {descriptionText.slice(0, breakIndex)}
                            <br />
                            {descriptionText.slice(breakIndex + 1)}
                        </>
                    );
                })()
            }
        </p>
    );
};

export default ModuleCardDescription;
